import { InjectionToken } from '@angular/core';

import { IOrganizationDetailsTabPlugin } from '../interfaces';

export const ORGANIZATION_DETAILS_TAB_PLUGIN = new InjectionToken<IOrganizationDetailsTabPlugin[]>(
  'OrganizationDetailsTabPlugin',
);
